
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';
import { type ErrorLog } from '@/utils/logger';
import ErrorLogItem from './ErrorLogItem';

interface ErrorLogTableProps {
  errors: ErrorLog[];
  onRemoveError: (index: number) => void;
}

const ErrorLogTable: React.FC<ErrorLogTableProps> = ({ errors, onRemoveError }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[180px]">Time</TableHead>
            <TableHead className="w-[150px]">Component</TableHead>
            <TableHead>Error</TableHead>
            <TableHead className="w-[120px]">Reported</TableHead>
            <TableHead className="w-[100px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {errors.map((error, index) => (
            <ErrorLogItem
              key={index}
              error={error}
              index={index}
              onRemove={onRemoveError}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ErrorLogTable;
